<template>
  <lottie-player v-if="showConfetti" class="confetti-animation"
                 :src="JSON.stringify(require('@/assets/animations/ConfettiSavings.json'))"
                 :preserveAspectRatio="'xMidYMax'"
                 :autoplay="true"
                 :loop="false"/>
</template>

<script>
export default {
  name: 'ConfettiAnimation',
  data() {
    return {
      showConfetti: false,
    };
  },
  methods: {
    startConfettiAnimation() {
      this.showConfetti = true;
      setTimeout(() => {
        this.showConfetti = false;
      }, 2000);
    },
  },
};
</script>

<style scoped lang="scss">
  .confetti-animation {
    position: absolute;
    width: 85%;
    height: fit-content;
    left:0;
    right:0;
    margin-left:auto;
    margin-right:auto;
    pointer-events: none; // to prevent the animation from blocking the click event on the expandable section
  }
</style>
